import { render, staticRenderFns } from "./ContentStreamTodo.vue?vue&type=template&id=53bc43d2&"
import script from "./ContentStreamTodo.vue?vue&type=script&lang=ts&"
export * from "./ContentStreamTodo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports